import { cn } from "@aichat/ui/lib/utils";

const ConfettiIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={cn(["w-5 h-5", className])}
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6530_13091)">
        <path
          d="M30.9327 49.0683L25.3906 41.1689L17.0134 35.1489C16.3679 36.8506 15.8133 38.3126 15.168 40.0143L20.4308 47.3905L27.5773 52.4236L30.9326 52.0567L30.9327 49.0683Z"
          fill="#FC6DAE"
        />
        <path
          d="M20.8658 59.1346L17.5104 53.8231L11.4763 49.7451C10.8309 51.4468 10.2764 52.9088 9.63086 54.6105L12.6952 59.7811L17.5104 62.49H20.1665L20.8658 59.1346Z"
          fill="#FC6DAE"
        />
        <path
          d="M27.5762 52.4236L32.7147 59.5173L39.9855 64.8328C41.6872 64.1875 43.1492 63.6329 44.8509 62.9874L38.7254 55.2993L30.9316 49.0682C29.7579 50.2417 28.7497 51.2501 27.5762 52.4236Z"
          fill="#F73D7F"
        />
        <path
          d="M17.5098 62.4899L20.3769 67.0571L25.3893 70.3694C27.091 69.7239 28.553 69.1694 30.2546 68.524L26.2294 62.9875L20.8652 59.1345C19.6916 60.308 18.6833 61.3164 17.5098 62.4899Z"
          fill="#F73D7F"
        />
        <path
          d="M35.964 44.0351L29.2533 35.1489L19.78 27.8507C18.9003 30.1696 17.8913 32.8299 17.0117 35.1489C18.6957 36.8327 29.236 47.3733 30.931 49.0683L34.4541 47.7597L35.964 44.0351Z"
          fill="#FFD92E"
        />
        <path
          d="M30.9316 49.0683C32.6154 50.7521 43.156 61.2926 44.851 62.9876C47.1698 62.108 49.83 61.099 52.1489 60.2194L44.851 51.0287L35.9648 44.0353C34.3647 45.6352 32.5314 47.4683 30.9316 49.0683Z"
          fill="#FCBE00"
        />
        <path
          d="M34.2869 35.6466H30.9316V32.2912C33.3353 29.8877 36.2864 26.9366 37.6424 25.5803C40.3311 22.8916 41.8121 19.3167 41.8121 15.514C41.8121 11.7116 40.3312 8.13663 37.6424 5.44779C38.8159 4.27429 39.8243 3.26591 40.9978 2.09241C48.3862 9.48065 48.446 21.4875 40.9978 28.9358L36.8034 33.13L34.2869 35.6466Z"
          fill="#C6EA4B"
        />
        <path
          d="M47.7089 49.0682H44.3535V45.7128C46.6798 43.3866 48.7397 41.3266 51.0644 39.0019C54.6493 35.417 59.4158 33.4425 64.486 33.4425C69.5558 33.4425 74.3225 35.4167 77.9077 39.0019C76.7342 40.1754 75.7258 41.1838 74.5523 42.3573C71.7769 39.5821 68.1315 38.1944 64.486 38.1944C60.8405 38.1944 57.1952 39.5821 54.4198 42.3573C52.0969 44.6801 50.0384 46.7388 47.7089 49.0682Z"
          fill="#55C8FF"
        />
        <path
          d="M23.1191 7.05554H27.8644V11.8008H23.1191V7.05554Z"
          fill="#84DFFF"
        />
        <path
          d="M27.8633 16.5461H32.6086V21.2914H27.8633V16.5461Z"
          fill="#84DFFF"
        />
        <path
          d="M61.0801 45.0178H65.8254V49.7631H61.0801V45.0178Z"
          fill="#92E200"
        />
        <path
          d="M70.5714 59.2537C68.9119 59.2537 67.4859 59.2537 65.8262 59.2537C65.8262 57.5941 65.8262 54.5084 65.8262 54.5084H70.5714V59.2537Z"
          fill="#92E200"
        />
        <path
          d="M70.5723 21.2914H75.3175V26.0367H70.5723V21.2914Z"
          fill="#55C8FF"
        />
        <path
          d="M51.5898 2.3103H56.3351V7.05558H51.5898V2.3103Z"
          fill="#C6EA4B"
        />
        <path
          d="M61.4284 18.5721L66.4595 15.2017L70.3054 9.69508C70.6607 7.81247 72.0169 6.46813 73.8846 6.11603L77.4529 4.20843L78.3229 1.67761C77.7361 1.09094 77.2318 0.586833 76.6451 0C74.3631 2.28185 71.8282 0.342767 68.1802 3.99094C65.2603 6.91071 65.7982 9.54022 65.137 11.1179C64.758 12.0226 63.7568 13.0239 62.8516 13.4034C61.7219 13.8769 60.1463 13.7301 58.2504 14.6291C56.448 15.4837 54.7609 17.1702 53.9059 18.9735C52.6029 21.7218 53.5749 23.07 51.7324 24.9127C52.3191 25.4995 52.8234 26.0036 53.41 26.5903L55.6294 25.7204L57.8488 22.1517C58.2056 20.2598 59.5392 18.9284 61.4284 18.5721Z"
          fill="#FC6DAE"
        />
        <path
          d="M39.3207 40.6798C38.8217 40.1807 22.1257 23.4848 21.6267 22.9856C20.9812 24.6871 20.4266 26.1493 19.7812 27.8508C20.6808 28.7502 35.0659 43.1356 35.9653 44.035L39.0572 43.7715L39.3207 40.6798Z"
          fill="#FCBE00"
        />
        <path
          d="M9.63054 54.6104C9.35879 55.3267 0.27143 79.2842 0 80L9.63054 72.5405L17.5101 62.49C16.5574 61.5372 10.5894 55.5694 9.63054 54.6104Z"
          fill="#FFD92E"
        />
        <path
          d="M27.577 52.4237C26.1782 51.0249 16.6415 41.4883 15.1676 40.0143C14.1643 42.6591 12.0628 48.1996 11.4766 49.7451C12.6175 50.8862 19.7216 57.9902 20.866 59.1346L25.3902 56.8811L27.577 52.4237Z"
          fill="#FFD92E"
        />
        <path
          d="M67.5441 15.8109C69.5513 13.8037 69.8171 12.2789 70.3046 9.69507C67.1999 12.7996 64.5323 15.4674 61.4277 18.5721C63.8616 18.1129 65.4701 17.8851 67.5441 15.8109Z"
          fill="#F73D7F"
        />
        <path
          d="M80.0006 3.35535C79.4138 2.76867 78.9097 2.26457 78.323 1.67773C76.7707 3.22991 75.4369 4.56381 73.8848 6.11615C75.5002 5.81119 77.6457 5.71027 80.0006 3.35535Z"
          fill="#F73D7F"
        />
        <path
          d="M57.8489 22.1517C56.2964 23.7041 54.9627 25.0381 53.4102 26.5903C53.9968 27.1771 54.5011 27.6812 55.0878 28.2681C57.3642 25.9916 57.5031 23.9837 57.8489 22.1517Z"
          fill="#F73D7F"
        />
        <path
          d="M52.1489 60.2193C53.8506 59.5739 55.3126 59.0194 57.0143 58.3738C56.5152 57.8748 39.8194 41.1789 39.3202 40.6798C38.1467 41.8533 37.1385 42.8617 35.9648 44.0352C36.8644 44.9346 51.2495 59.3199 52.1489 60.2193Z"
          fill="#FF9000"
        />
        <path
          d="M17.5101 62.49C16.5387 63.4615 0.971516 79.0285 0 80.0001C0.716379 79.7283 24.6739 70.6411 25.3896 70.3695C24.4369 69.4168 18.4689 63.4489 17.5101 62.49Z"
          fill="#FCBE00"
        />
        <path
          d="M20.8652 59.1345C22.0062 60.2754 29.1103 67.3796 30.2547 68.524C32.8997 67.5207 38.4402 65.4192 39.9855 64.833C38.5868 63.4342 29.0502 53.8976 27.5762 52.4236C26.7641 53.2357 21.6825 58.3172 20.8652 59.1345Z"
          fill="#FCBE00"
        />
      </g>
      <defs>
        <clipPath id="clip0_6530_13091">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ConfettiIcon;
